module.exports = __webpack_public_path__ + "static/media/lato-regular.c369759b.ttf";